import React, { useEffect, useState } from "react";
import PanelHead from "../../../Panel/PanelHead";
import PanelBody from "../../../Panel/PanelBody";
import { FormWhatsappGroup } from "./FormWhatsappGroup";
import { LinearProgress } from "@mui/material";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";

export const AddPanelWhatsappGroup = () => {
  const [loading, setLoader] = useState(true);
  const [Panels, setPanels] = useState([]);

  const get_panels = async () => {
    const { response } = await Helper.Get({
      url: api_Routes.Groups.PanelView,
      hasToken: true,
    });
    if (response) {
      setPanels(response);
      setLoader(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    get_panels();
  }, []);

  return (
    <div>
      <PanelHead title="Add Whatsapp Group" />
      <PanelBody
        content={
          loading ? <LinearProgress /> : <FormWhatsappGroup Panels={Panels} loading={loading} />
        }
      />
    </div>
  );
};
